function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M114.239 46.105c3.162 31.319-11.194 66.044-42.037 69.159-30.843 3.113-68.708-13.431-71.87-44.75C-2.83 39.194 16.793 0 47.794 0c16.272 0 63.284 14.787 66.445 46.105",
  fill: "currentColor",
  fillRule: "nonzero"
});

function Svg001(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 116",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTE1IDExNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIiPgogIDxwYXRoIGQ9Ik0xMTQuMjM5IDQ2LjEwNWMzLjE2MiAzMS4zMTktMTEuMTk0IDY2LjA0NC00Mi4wMzcgNjkuMTU5LTMwLjg0MyAzLjExMy02OC43MDgtMTMuNDMxLTcxLjg3LTQ0Ljc1Qy0yLjgzIDM5LjE5NCAxNi43OTMgMCA0Ny43OTQgMGMxNi4yNzIgMCA2My4yODQgMTQuNzg3IDY2LjQ0NSA0Ni4xMDUiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPg==";
export { Svg001 as ReactComponent };